import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { filmRoute } from './routes';
import { MovieNotFoundError } from './lib/error';
import { MovieNotFound } from './components/MovieNotFound/MovieNotFound';
import {
    moviePromoBlockWidget,
    movieCardModalWidget,
    playerSeriesStructureWidget,
} from './widgets';
import { MoviePromoBlock } from './components/MoviePromoBlock/MoviePromoBlock';
import { MovieCardModal } from './components/MovieCardModal/MovieCardModal';
import { PlayerSeriesStructure } from './components/PlayerSeriesStructure/PlayerSeriesStructure';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: filmRoute,
        meta: {
            plusPaymentPage: 'MovieCard',
            page: 'film',
        },
        component: lazy(() => import('./components/MovieCard/MovieCard')),
        fallback: RouteSkeleton,
    });

    ctx.addError({
        is: (error) => error instanceof MovieNotFoundError,
        component: MovieNotFound,
    });

    ctx.addWidget({
        widget: moviePromoBlockWidget,
        component: MoviePromoBlock,
    });

    ctx.addWidget({
        widget: movieCardModalWidget,
        component: MovieCardModal,
    });

    ctx.addWidget({
        widget: playerSeriesStructureWidget,
        component: PlayerSeriesStructure,
    });
});

export * from './routes';
export * from './widgets';

export default scenario;
